import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconCommenting: TIconComponent = props => (
    <Icon viewBox="0 0 140 101" {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="140" height="101" fill="none">
            <path
                d="M100.866 20.6335C120.744 21.6112 136.904 37.7401 137.945 57.6146C138.447 67.2081 135.445 76.0598 130.165 83.1012L132.746 93.4239C133.314 95.6985 131.097 97.6756 128.903 96.8521L119.048 93.1573C112.426 97.155 104.553 99.2917 96.1207 98.7004C83.8354 97.837 73.0719 91.2056 66.513 81.5467C62.5769 75.7514 60.1554 68.866 59.8253 61.4836C58.9818 42.6012 71.5356 26.5068 88.78 21.9032C92.6091 20.882 96.6685 20.4267 100.864 20.6317L100.866 20.6335Z"
                fill="#95C11F"
            />
            <path
                d="M88.7825 21.9051C92.6116 20.8838 96.671 20.4286 100.866 20.6335C120.745 21.6112 136.904 37.7401 137.945 57.6146C138.448 67.2081 135.446 76.0598 130.166 83.1012L132.747 93.4239C133.315 95.6985 131.098 97.6756 128.903 96.8521L119.049 93.1573C112.426 97.155 104.554 99.2918 96.1214 98.7005C83.8361 97.8371 73.0726 91.2056 66.5137 81.5467"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M84.4502 70.5112V75.6825H114.615V70.5112H84.4502Z"
                fill="#D5E6A5"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M90.4112 56.9508V62.1221H114.615V56.9508H90.4112Z"
                fill="#D5E6A5"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M95.3496 43.3885V48.5598H115.19V43.3885H95.3496Z"
                fill="#D5E6A5"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.7069 7.91827C18.1865 14.5044 10.96 25.9553 10.2762 39.0279C9.77376 48.6214 12.7757 57.4731 18.0559 64.5145L15.4747 74.8372C14.907 77.1118 17.1235 79.0889 19.3183 78.2654L29.173 74.5705C35.7955 78.5683 43.6676 80.705 52.1003 80.1137C71.7571 78.7334 87.516 62.5845 88.3957 42.8987C89.426 19.8245 70.4511 0.913124 47.3552 2.0486C42.9348 2.26627 38.6976 3.23306 34.7688 4.82382"
                fill="#D5E6A5"
            />
            <path
                d="M28.7069 7.91827C18.1865 14.5044 10.96 25.9553 10.2762 39.0279C9.77376 48.6214 12.7757 57.4731 18.0559 64.5145L15.4747 74.8372C14.907 77.1118 17.1235 79.0889 19.3183 78.2654L29.173 74.5705C35.7955 78.5683 43.6676 80.705 52.1003 80.1137C71.7571 78.7334 87.516 62.5845 88.3957 42.8986C89.426 19.8245 70.4511 0.913124 47.3552 2.0486C42.9348 2.26627 38.6976 3.23306 34.7688 4.82382"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M56.657 98.354C59.9888 98.354 62.6899 95.653 62.6899 92.3211C62.6899 88.9892 59.9888 86.2882 56.657 86.2882C53.3251 86.2882 50.6241 88.9892 50.6241 92.3211C50.6241 95.653 53.3251 98.354 56.657 98.354Z"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M96.5149 13.6792C98.8951 13.6792 100.825 11.7496 100.825 9.36943C100.825 6.98923 98.8951 5.05969 96.5149 5.05969C94.1346 5.05969 92.2051 6.98923 92.2051 9.36943C92.2051 11.7496 94.1346 13.6792 96.5149 13.6792Z"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.17136 14.938C10.0274 14.938 12.3427 12.6227 12.3427 9.76667C12.3427 6.91062 10.0274 4.59534 7.17136 4.59534C4.31531 4.59534 2.00003 6.91062 2.00003 9.76667C2.00003 12.6227 4.31531 14.938 7.17136 14.938Z"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M33.92 50.4172V55.5885H64.0845V50.4172H33.92Z"
                fill="#95C11F"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M33.92 36.8985V41.9773H64.0301V36.8985H33.92Z"
                fill="#95C11F"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M33.92 23.2945V28.5547L64.5743 28.5547V23.2945H33.92Z"
                fill="#95C11F"
                stroke="#333333"
                strokeWidth="2.77521"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </Icon>
);
